import styled from 'styled-components'
import { black, textMuted, grey } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'
import { Button } from '@components/Button'
import { cardSurface } from '@components/Card'





export const ProfileContent = styled.div`
	${cardSurface}
	padding: 48px 32px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 32px;

	${media.phone} {
		padding: 24px 16px;
		gap: 20px;
	}
`

export const ProfileAvatar = styled.div`
	width: 150px;
	height: 150px;
	border-radius: 50%;
	background: ${grey};
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${textMuted};
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	${media.phone} {
		width: 110px;
		height: 110px;
	}
`

export const ProfileInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	text-align: center;
`

export const ProfileName = styled.h2`
	${text.heading}
	color: ${black};
	margin: 0;
`

export const ProfileEmail = styled.div`
	font-size: ${fontSizes.body};
	color: ${textMuted};
`

export const ProfileActions = styled.div`
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
	justify-content: center;
`

export const EditButton = styled(Button).attrs({ variant: 'secondary' as const })``


